import { TypesFiltersGroup } from '../../components/LandingFiltersBar/commonFiltersGroups/TypeFiltersGroup/TypeFiltersGroup';
import { StartEndDateOptionsView } from '../../components/LandingFiltersBar/StartEndDateOptionsView/StartEndDateOptionsView';
import { StartEndDatesFiltersGroup } from '../../components/LandingFiltersBar/commonFiltersGroups/StartEndDatesFiltersGroup/StartEndDatesFiltersGroup';
import { LocationFiltersGroup } from '../../components/LandingFiltersBar/commonFiltersGroups/LocationFiltersGroup/LocationFiltersGroup';
import { GradesOptionsView } from '../../components/LandingFiltersBar/GradesOptionsView/GradesOptionsView';
import { GradesFiltersGroup } from '../../components/LandingFiltersBar/commonFiltersGroups/GradeFiltersGroup/GradeFiltersGroup';
import { AgesOptionsView } from '../../components/LandingFiltersBar/AgesOptionsView/AgesOptionsView';
import { AgesFiltersGroup } from '../../components/LandingFiltersBar/commonFiltersGroups/AgeFiltersGroup/AgesFiltersGroup';
import { TimeFiltersGroup } from '../../components/LandingFiltersBar/commonFiltersGroups/TimeFiltersGroup/TimeFiltersGroup';
import React from 'react';

export const commonSessionsFilterGroups = [
  {
    key: 'type',
    displayText: 'Type',
    renderFiltersGroup: (props) => <TypesFiltersGroup {...props} />
  },
  {
    key: 'date',
    displayText: 'Date',
    renderOptionsView: (options) => <StartEndDateOptionsView {...options} />,
    renderFiltersGroup: (props) => <StartEndDatesFiltersGroup {...props} />
  },
  {
    key: 'location',
    displayText: 'Location',
    renderFiltersGroup: (props) => <LocationFiltersGroup {...props} />
  },
  {
    key: 'grade',
    displayText: 'Grade',
    renderOptionsView: (props) => <GradesOptionsView {...props} />,
    renderFiltersGroup: (props) => <GradesFiltersGroup {...props} />
  },
  {
    key: 'age',
    displayText: 'Age',
    renderOptionsView: (props) => <AgesOptionsView {...props} />,
    renderFiltersGroup: (props) => <AgesFiltersGroup {...props} />
  },
  {
    key: 'timeOfDay',
    displayText: 'Time',
    renderFiltersGroup: (props) => <TimeFiltersGroup {...props} />
  }
];

export const productsFilterGroups = [
  {
    key: 'age',
    displayText: 'Age',
    renderOptionsView: (props) => <AgesOptionsView {...props} />,
    renderFiltersGroup: (props) => <AgesFiltersGroup {...props} />
  }
];

export const activitiesFilterGroups = [
  {
    key: 'type',
    displayText: 'Type',
    renderFiltersGroup: (props) => <TypesFiltersGroup {...props} />
  },
  {
    key: 'grade',
    displayText: 'Grade',
    renderOptionsView: (props) => <GradesOptionsView {...props} />,
    renderFiltersGroup: (props) => <GradesFiltersGroup {...props} />
  },
  {
    key: 'age',
    displayText: 'Age',
    renderOptionsView: (props) => <AgesOptionsView {...props} />,
    renderFiltersGroup: (props) => <AgesFiltersGroup {...props} />
  }
];
